const AMOUNT = 'amount';
const H = 'h';
const KG = 'kg';
const M = 'm';
const MM = 'mm';
const M2 = 'm2';
const MM2 = 'mm2';

export { AMOUNT, H, KG, M, M2, MM2, MM };
